import React from "react";

export type SortColumn = "start_time" | "accuracy" | "agent" | "model" | "dataset_size";
export type SortDirection = "asc" | "desc";

interface SortHeaderProps {
  column: SortColumn;
  children: React.ReactNode;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export const SortHeader: React.FC<SortHeaderProps> = ({
  column,
  children,
  sortColumn,
  sortDirection,
  onSort,
}) => (
  <th
    className="al-p-3 al-text-left al-text-sm al-font-medium al-cursor-pointer hover:al-bg-gray-200"
    onClick={() => onSort(column)}
  >
    {children}
    {sortColumn === column && (
      <span className="al-ml-1">{sortDirection === "asc" ? "↑" : "↓"}</span>
    )}
  </th>
);
